import Device from '../../../../../../../../../../../constants/deviceSizes';
import { small } from '../../../../../../../../../../../constants/fonts';

const fieldStyle = {
  display: 'flex',
  flexDirection: 'column',
  borderBottomStyle: 'solid',
  alignItems: 'flex-start',
  justifyContent: 'center',
  margin: 'auto 0',
  height: '100%',
  textAlign: 'left'
};

export default {
  field: {
    ...fieldStyle
  },
  lastField: {
    ...fieldStyle,
    borderWidth: 0
  },
  element: {
    whiteSpace: 'normal',
    maxWidth: '100%',
    height: '100%',
    [Device.mobile]: {
      fontSize: small
    }
  }
};
